
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.156 17.5a3.594 3.594 0 110-7.187 3.594 3.594 0 010 7.187zm0-5.938a2.344 2.344 0 100 4.69 2.344 2.344 0 000-4.69zM4.844 17.5a3.594 3.594 0 110-7.187 3.594 3.594 0 010 7.187zm0-5.938a2.344 2.344 0 100 4.689 2.344 2.344 0 000-4.689zM12.5 5a1.245 1.245 0 001.25-1.254A1.232 1.232 0 0012.508 2.5 1.25 1.25 0 0012.5 5z","fill":"#000"}}),_c('path',{attrs:{"d":"M14.357 7.5h-1.709a.156.156 0 01-.137-.081l-1.24-2.273a1.212 1.212 0 00-1.929-.302l-2.729 2.75c-.229.234-.36.547-.363.875 0 .68.492.922.723 1.058 1.113.642 1.897 1.11 2.327 1.371a.156.156 0 01.075.134v2.7c0 .336.259.625.595.641a.624.624 0 00.655-.623v-3.36a.625.625 0 00-.26-.507L8.92 8.843a.156.156 0 01-.023-.234l1.64-1.75a.156.156 0 01.251.031l.853 1.538a.626.626 0 00.546.322h2.188A.625.625 0 0015 8.095a.638.638 0 00-.643-.595z","fill":"#000"}})])
          )
        }
      }
    